import { render, staticRenderFns } from "./myindex.vue?vue&type=template&id=94100898&scoped=true&"
import script from "./myindex.vue?vue&type=script&lang=ts&"
export * from "./myindex.vue?vue&type=script&lang=ts&"
import style0 from "./myindex.vue?vue&type=style&index=0&id=94100898&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94100898",
  null
  
)

export default component.exports